import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const UserSchema = withDefaults({
  type: 'user',
  objectExtensions: ['user'],
  fields: [
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'syfGraceActive',
    },
    {
      kind: 'attribute',
      name: 'permissions',
    },
    {
      kind: 'attribute',
      name: 'canAccessAdmin',
    },
    {
      kind: 'attribute',
      name: 'roleClaims',
    },
    {
      kind: 'attribute',
      name: 'phoneCapturePrompt',
    },
    {
      kind: 'attribute',
      name: 'phoneCaptureCard',
    },
    {
      kind: 'belongsTo',
      name: 'person',
      type: 'person',
      options: {
        async: false,
        inverse: 'user',
      },
    },
    {
      kind: 'belongsTo',
      name: 'agent',
      type: 'agent',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'answerProfile',
      type: 'answer-profile',
      options: {
        async: false,
        inverse: 'user',
      },
    },
    {
      kind: 'hasMany',
      name: 'accounts',
      type: 'account',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'remoteEvents',
      type: 'remote-event',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'recommendations',
      type: 'recommendation',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'employees',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'families',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'roleViews',
      type: 'role-view',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'userRoles',
      type: 'user-role',
      options: {
        async: false,
        inverse: 'user',
      },
    },
    {
      kind: 'hasMany',
      name: 'logins',
      type: 'login',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'strategyFinderResults',
      type: 'strategy-finder-result',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'agreements',
      type: 'agreement',
      options: {
        async: false,
        inverse: 'user',
      },
    },
    {
      kind: 'belongsTo',
      name: 'usageAgreement',
      type: 'agreement',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'privacyAgreement',
      type: 'agreement',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'customRegisterAgreements',
      type: 'agreement',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'emailAddresses',
      type: 'email-address',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'wellnessTrain',
      type: 'wellness-train',
      options: {
        async: false,
        inverse: 'user',
      },
    },
  ],
});

export default UserSchema;
